import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2962fd5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "reports-pagination" }
const _hoisted_2 = {
  key: 0,
  id: "reports-pagination-list",
  class: "pagination"
}
const _hoisted_3 = ["onClick"]

import { computed, ref, onMounted } from 'vue';
import store from '@/store';
import { ReportsState } from '@/store/reports/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPagination',
  props: {
    total: {},
    current: {},
    limit: {}
  },
  emits: ['pageReports'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props;

const reportsState = computed(() => store.state.reports as ReportsState);

// Convert getters to computed properties
const totalReports = computed(() => props.total);
const pageLimit = computed(() => parseInt(props.limit as string, 10));
const currentPage = computed(() => parseInt(props.current as string, 10));

const paging = computed(() => {
  const numPages = Math.ceil(parseInt(totalReports.value as string, 10) / pageLimit.value);
  return {
    currentPage: currentPage.value,
    numPages
  };
});

const pageIsActive = (p: number, classNames: string) => {
  const classes = [classNames];
  if (p === currentPage.value) {
    classes.push('active');
  }
  return classes.join(' ');
};

const setPage = (value: number) => {
  emit('pageReports', value)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (paging.value.numPages)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paging.value.numPages, (page, $index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: $index,
              class: _normalizeClass(pageIsActive($index+1, 'page-item'))
            }, [
              _createElementVNode("button", {
                onClick: ($event: any) => (setPage(page)),
                class: "page-link"
              }, _toDisplayString(page), 9, _hoisted_3)
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})